export default "__VITE_ASSET__6334a203__"